module.exports = __webpack_public_path__ + "static/media/house-6.896dab53.jpeg";